import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "../layout/Layout";
import { WelcomePage } from "../pages/WelcomePage";
import { InstallMcpPage } from "../pages/InstallMcpPage";
import { MeetingsPage } from "../pages/MeetingsPage";
import { MeetingDetailPage } from "../pages/MeetingDetailPage";
import { DemoPage } from "../pages/DemoPage";

export const CRM = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<WelcomePage />} />
      <Route path="/install-mcp" element={<InstallMcpPage />} />
      <Route path="/meetings" element={<MeetingsPage />} />
      <Route path="/meetings/:id" element={<MeetingDetailPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Layout>
);
